var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"single-line":"","return-object":"","item-value":"id","item-text":"name","prepend-inner-icon":"mdi-share-variant","value":_vm.value,"items":_vm.channels,"loading":_vm.loading},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-list-item',_vm._g(_vm._b({},'v-list-item',attrs,false),on),[_c('reservation-channel',{attrs:{"channel":item}})],1)]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('reservation-channel',{attrs:{"channel":item}})]}}])},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }